module.exports = __webpack_public_path__ + "img/IMG_0380.c79df3b9.png";